// Module
var code = "<div class=\"field-header type\"></div> <div class=\"field-section\"> <label>Key Field</label> <div class=\"field\"></div> </div>";
// Exports
export default code;